import classNames from "classnames";
import type React from "react";
import {memo} from "react";

import {Box} from "../ui/box";

type Props = {
    className?: string;
};

const Placeholder: React.FC<Props> = ({className}) => {
    return <Box className={classNames("w-1/3 flex-grow md:hidden", className)} />;
};

export default memo(Placeholder);
